<ng-template #casesCell>
  <div class="fill-content flexbox-container flex-centered p-10">
    <div class="icon-count flexbox-container">
      <i class="fa fa-file"></i>
    </div>
    <div class="number ml-4">{{casesCount}}</div>
  </div>
</ng-template>

<ng-container *ngIf="!tooltipComponent || !tooltipData">
  <ng-container *ngTemplateOutlet="casesCell"></ng-container>
</ng-container>

<div *ngIf="tooltipComponent && tooltipData"
     [tooltip]="tooltipComponent"
     [activeContent]="true"
     [data]="tooltipData"
     class="tooltip-hover-area fill-content"
>
  <ng-container *ngTemplateOutlet="casesCell"></ng-container>
</div>
